import { initI18n } from '@wix/wix-i18n-config';
import { createHttpClient } from '@wix/http-client';
import { calculateAppEnvironment, createHub } from '@wix/error-monitor';
import { ErrorHandler } from '@wix/error-handler';
import Experiments, { ReadOnlyExperiments } from '@wix/wix-experiments';
import { create as createFedopsLogger } from '@wix/fedops-logger';
import { factory as webBiLoggerFactory } from '@wix/web-bi-logger';
import * as Sentry from '@sentry/browser';
import { EssentialsPartialGetters } from './EssentialsPartialGetters';
import { DataCapsule, LocalStorageCachedCapsule, LocalStorageStrategy, WixStorageStrategy, } from '@wix/data-capsule';
import { createCurrencyFormatterWithDefaults, formatAddress } from '@wix/l10n';
export class EssentialsPartialDelegate extends EssentialsPartialGetters {
    constructor({ experiments: experimentsOptions, fedops: fedopsOptions, errorMonitor: errorMonitorOptions, httpClient: httpClientOptions, i18n: i18nOptions, dataCapsule: dataCapsuleOptions, errorHandler: errorHandlerOptions, parent, }) {
        super();
        const environment = this.getEnvironment(parent);
        this.errorHandler = errorHandlerOptions
            ? new ErrorHandler({
                environment,
                biLoggerOrFactory: webBiLoggerFactory,
                createExperiments: (opts) => new Experiments(opts),
                createI18n: (opts) => initI18n({
                    locale: environment.language,
                    ...opts,
                }),
                createErrorMonitor: (opts) => createHub({
                    Sentry,
                    environment: calculateAppEnvironment(),
                    ...opts,
                }),
                ...errorHandlerOptions,
            })
            : undefined;
        this.httpClient = httpClientOptions
            ? createHttpClient({
                ...httpClientOptions,
                errorHandler: this.errorHandler,
            })
            : null;
        const httpClient = this.httpClient ?? parent?.asPartial.httpClient;
        this.dataCapsule = dataCapsuleOptions
            ? new DataCapsule({
                ...dataCapsuleOptions,
                strategy: dataCapsuleOptions.storageStrategy === 'userPreferences' &&
                    httpClient
                    ? LocalStorageCachedCapsule({
                        remoteStrategy: new WixStorageStrategy({
                            httpClient,
                        }),
                    })
                    : new LocalStorageStrategy(),
            })
            : null;
        this.experiments = experimentsOptions
            ? 'scopes' in experimentsOptions
                ? new Experiments({ scopes: experimentsOptions.scopes })
                : new ReadOnlyExperiments({ experiments: experimentsOptions.bag })
            : null;
        this.fedopsLogger = fedopsOptions
            ? createFedopsLogger(fedopsOptions.appName)
            : null;
        this.errorMonitor = errorMonitorOptions
            ? createHub({
                Sentry,
                environment: calculateAppEnvironment(),
                ...errorMonitorOptions,
            })
            : null;
        this.i18n = i18nOptions
            ? initI18n({
                locale: environment.language,
                ...i18nOptions,
            })
            : null;
        this.biLoggerFactory = webBiLoggerFactory;
        this.biLogger = this.biLoggerFactory().logger();
        this.createCurrencyFormatter = createCurrencyFormatterWithDefaults({
            language: environment.language,
        });
        this.formatAddress = formatAddress;
    }
}
//# sourceMappingURL=EssentialsPartialDelegate.js.map